import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { PopupService, UiIconModel } from '@local/ui-infra';
import { EventsService, LogService, ServicesRpcService } from '@shared/services';
import { DownloadsService } from '@shared/services/downloads.service';
import { FlagsService } from '@shared/services/flags.service';
import { KeyboardService } from '@shared/services/keyboard.service';
import { ResourcesService } from '@shared/services/resources.service';
import { RouterService } from '@shared/services/router.service';
import * as moment from 'moment/moment';
import { IActionItem } from 'src/app/bar/models/action-item.model';
import { CalendarService } from 'src/app/bar/services/calendar.service';
import { HubService } from 'src/app/bar/services/hub.service';
import { CommandBarService } from '../../../../services/command-bar.service';
import { CommandsService } from '../../../../services/commands/commands.service';
import { CalendarEvent } from '../../../results';
import { ResultCommandBuilder } from '../../../results/services/result-command-builder.service';
import { CalendarBullet, CalendarDisplayModel } from '../../models/calendar-display-model';
import { HomeResultItemComponent } from '../../../calendar-page/home-result-item/home-result-item.component';
import { SearchPopUpService } from '../../../special-views/search-popup/search-popup.service';
@Component({
  selector: 'calendar-widget-item',
  templateUrl: './calendar-widget-item.component.html',
  styleUrls: ['./calendar-widget-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CalendarWidgetItemComponent extends HomeResultItemComponent<CalendarEvent> {
  @Input() isSmallScreen: boolean;
  @Input() soonEvent: CalendarEvent;

  get displayModel(): CalendarDisplayModel {
    return this._displayModel as CalendarDisplayModel;
  }

  set displayModel(value: CalendarDisplayModel) {
    this._displayModel = value;
  }

  constructor(
    cdr: ChangeDetectorRef,
    eventsService: EventsService,
    services: ServicesRpcService,
    logService: LogService,
    commandsService: CommandsService,
    commandBarService: CommandBarService,
    popupService: PopupService,
    keyboardService: KeyboardService,
    commandBuilder: ResultCommandBuilder,
    resourcesService: ResourcesService,
    routerService: RouterService,
    downloadsService: DownloadsService,
    private calendarService: CalendarService,
    flagsService: FlagsService,
    hubService: HubService,
    searchPopUpService: SearchPopUpService
  ) {
    super(
      cdr,
      eventsService,
      services,
      logService,
      commandsService,
      commandBarService,
      popupService,
      keyboardService,
      commandBuilder,
      resourcesService,
      routerService,
      hubService,
      downloadsService,
      flagsService,
      searchPopUpService
    );
  }

  protected async updateDisplayModel(): Promise<void> {
    await super.updateDisplayModel();
    if (!this.displayModel) return;
    this.displayModel.eventType = this.calendarService.getEventType(this.model.start, this.model.end);
    this.calendarService.setTimeFields(moment(this.model.originalStartDate), moment(this.model.originalEndDate), this.displayModel);
    this.displayModel.badge = this.model.view.badge;
    if (this.displayModel.badge?.text?.includes('Maybe')) this.displayModel.badge.text = 'Maybe';
    this.displayModel.joinAction = this.displayModel.actions.find((action) => action.id.includes('meeting'));
    this.displayModel.bullet = this.getBullet();
  }

  private getBullet(): CalendarBullet {
    const videoBulletNames = ['hangouts', 'zoom', 'teams'];
    const iconZoom: UiIconModel = { type: 'font', value: 'icon-camera' };
    const iconLocation: UiIconModel = { type: 'font', value: 'icon-location' };
    const zoomBullet = this.model.view.bullets?.find((bullet) =>
      bullet?.parts?.find((bulletPart) => videoBulletNames.includes(bulletPart.text?.toLowerCase()))
    );
    const zoom = zoomBullet?.parts?.[0];

    const locationBullet = this.model.view.bullets?.find((bullet) =>
      bullet?.parts?.find((bulletPart) => bulletPart.tooltip?.toLowerCase() === 'location')
    );
    const location = locationBullet?.parts?.[0];
    if (location) {
      return { id: 'location', icon: iconLocation, tooltip: location?.text };
    }
    if (zoom) {
      return { id: 'zoom', icon: iconZoom, tooltip: location?.text };
    }
  }

  protected getActions(): IActionItem[] {
    return [...this.calendarService.getMeetingsAction(this.model, this.shortcuts), { ...this.allActions.openPreview, hideIcon: true }];
  }

  onZoomMeeting() {
    if (this.displayModel.joinAction && this.displayModel.actions?.length) {
      this.onAction(this.displayModel.joinAction.id, 'mouse_click', 'join');
    }
  }
}
